import { CustomDatepickerI18n } from 'app/model/datepicker';
import { Config } from 'app/config.const';
import { NgbDateStruct, NgbDatepickerI18n, NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Component } from '@angular/core';
import * as moment from 'moment';
import { NgbCalendar } from '@ng-bootstrap/ng-bootstrap/datepicker/ngb-calendar';
import { NgbDate } from '@ng-bootstrap/ng-bootstrap/datepicker/ngb-date';
import { FormGroup, FormControl } from '@angular/forms';

@Component({
	selector: 'app-nuova-alternativa',
	templateUrl: './nuova.html',
	styleUrls: [ './nuova.css' ],
	providers: [{ provide: NgbDatepickerI18n, useClass: CustomDatepickerI18n }] // define custom NgbDatepickerI18n provider
})
export class NuovaAlternativaComponent {
	fromDate: NgbDate;
	toDate: NgbDate;
	tag: string;
	isCopying = false;
	formGroup = new FormGroup({ nome: new FormControl() });

	constructor(
		private calendar: NgbCalendar,
		public activeModal: NgbActiveModal
	) {
    	// FIXME: Questo sarebbe da mettere in configurazione statica...
		moment.locale(Config.language);

		const [ fromDate, toDate ] = this.toWeekSpan(calendar.getToday());
		this.fromDate = fromDate;
		this.toDate = toDate;
	}

	setWeek(date: NgbDateStruct) {
		const [ fromDate, toDate ] = this.toWeekSpan(new NgbDate(date.year, date.month, date.day));
		this.fromDate = fromDate;
		this.toDate = toDate;
	}

	toWeekSpan(day: NgbDate) {
		const week = day.toMoment().weekday(0);

		const begin = new NgbDate(week.year(), week.month() + 1, week.date());
		return [begin, this.calendar.getNext(begin, 'd', 6)];
	}

	isInside(date: NgbDate) {
		return (this.fromDate.before(date) && this.toDate.after(date)) ||
			this.fromDate.equals(date) || this.toDate.equals(date);
	}
}



// WEBPACK FOOTER //
// ./src/app/impostazioni_agenda/alternativa/nuova/nuova.ts